import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';
import routes from '../../constants/routes';

import { EventsTab } from '../../views/events/constant';

interface TopActionCardProps {
    count: number;
}
const TopActionCard: FC<React.PropsWithChildren<TopActionCardProps>> = ({
    count,
}) => {
    return (
        <Container>
            <ICONS.target
                width={20}
                height={20}
                color={aampeTheme.colors.orange11}
            />
            <Body>
                <Title>{count} Events are uncategorised</Title>
                <Description>
                    Set an event type to ensure accurate learning signals for
                    agents.
                </Description>
                <StyledLink
                    rel="noopener"
                    target="_blank"
                    to={`${routes.eventsMain}?tab=${EventsTab.UncategorizedEvents}`}
                >
                    See details
                </StyledLink>
            </Body>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    padding: aampeTheme.spacing4(4),
    background: aampeTheme.colors.orange01,
    borderRadius: aampeTheme.borderRadius.medium,
    border: `1px solid ${aampeTheme.colors.orange11}33`,
    columnGap: aampeTheme.spacing4(4),
});

const Body = styled.div({
    display: 'flex',
    flexDirection: 'column',
    rowGap: aampeTheme.spacing4(2),
});

const Title = styled.span({
    color: aampeTheme.colors.neutral09,
    fontWeight: aampeTheme.weights.heavy,
    fontSize: aampeTheme.size.font.default,
});

const Description = styled.span({
    color: aampeTheme.colors.textAccessibleWG01,
    fontWeight: aampeTheme.weights.medium,
    fontSize: aampeTheme.size.font.textMedium,
});

const StyledLink = styled(Link)(() => ({
    color: aampeTheme.colors.solidA01,
    fontSize: aampeTheme.size.font.default,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    fontWeight: aampeTheme.weights.medium,
}));

export default TopActionCard;
